<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M8.25 14.625H15.75" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.25 9.375H15.75" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.25 4.125H15.75" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.25 4.125L3 4.875L5.25 2.625" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.25 9.375L3 10.125L5.25 7.875" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.25 14.625L3 15.375L5.25 13.125" stroke="#F1F8FE" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>